import { graphQLFetch } from "../../../utils";
import { setBudgetItems } from "./setBudgetItems";
import { CREATE_BUDGET_ITEMS } from "../../queries";

export const createBudgetItem =
  ({ items }, callback) =>
  async (dispatch, getState) => {
    try {
      const variables = {
        input: items,
      };
      const data = await graphQLFetch(
        CREATE_BUDGET_ITEMS,
        variables,
        "mutation",
        getState,
        { cacheKeys: ["GetBudgetItems"] }
      );
      
      const { CreateBudgetItems } = data || {};
      
      // Better error handling for the callback
      if (CreateBudgetItems) {
        callback(CreateBudgetItems);
        dispatch(setBudgetItems(CreateBudgetItems || []));
      } else {
        // Call callback with error response to indicate failure
        callback({ success: false, message: "Failed to create budget items" });
      }
    } catch (error) {
      console.error("Error in createBudgetItem:", error);
      // Call callback with error response
      callback({ success: false, message: "Failed to create budget items" });
    }
  };
